import { render } from "./Select2.vue?vue&type=template&id=e9d7c790"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy PROD TeleData/wdw-vue-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__